/**
 * Common header component for offcanvas view
 *
 * Properties:
 *
 *      heading:            string, heading of page
 *      item:               object, containing attributes 'id', 'created', 'created_by', 'modified', 'modified_by'
 *      dispatch:           function, dispatch function
 *      onSubmitHandler:    function, called on submit
 *      onCloseHandler:     function, called on close
 *      closeButtonRef:     react ref, used to close and navigate
 *      returnUrl:          string, url to navigate to after closing
 *      isSaving:           boolean, indicating saving process
 */

import React, { useState, useEffect, Ref } from "react";
import { userActions, useSelector } from "inbooma-api";
// @ts-ignore
import { moment } from "../../../vendor";
// @ts-ignore
import { Biscuit } from "../../utils";
// @ts-ignore
import t from "../helpers/t";

type Props = {
  item: any;
  dispatch?: any;
  isSaving?: boolean;
  shouldClose?: boolean;
  noSaveButton?: any;
  saveButtonName?: string;
  returnUrl: string;
  lastMessage?: null | any;
  heading: string;
  onSubmitHandler?: any;
  isOrder?: boolean;
  onCloseHandler: any;
  executed?: null | string;
};
const OffcanvasHeader = (props: Props) => {
  const _user: any = useSelector((state: { users_data: { user: any } }) => state.users_data.user);
  //const [forceClose,setForceClose] = useState(false);
  const closeButtonRef: Ref<HTMLButtonElement> | undefined = React.createRef();
  // const abortButtonRef = React.createRef();

  const [createdBy, setCreatedBy] = useState({
    id: null,
    first_name: "",
    last_name: "",
    pending: false,
  });
  const [modifiedBy, setModifiedBy] = useState({
    id: null,
    first_name: "",
    last_name: "",
    pending: false,
  });

  if (typeof props.item.created_by !== "undefined" && createdBy.id === null) {
    props.dispatch(
      userActions.getUser({
        token: Biscuit.get("token"),
        id: props.item.created_by,
      }),
    );
    setCreatedBy({
      id: props.item.created_by,
      first_name: "",
      last_name: "",
      pending: true,
    });
  }

  const getUsernameById = (id?: null | string) => {
    if (typeof id === "undefined" || id == null) return t("unknown", null, "capital");

    if (createdBy.id == id) {
      if (createdBy.first_name == "" && createdBy.last_name == "")
        return t("unknown", null, "capital");
      if (createdBy.first_name == "") return createdBy.last_name;
      if (createdBy.last_name == "") return createdBy.first_name;
      return createdBy.first_name + " " + createdBy.last_name;
    }

    if (modifiedBy.id == id) {
      if (modifiedBy.first_name == "" && modifiedBy.last_name == "")
        return t("unknown", null, "capital");
      if (modifiedBy.first_name == "") return modifiedBy.last_name;
      if (modifiedBy.last_name == "") return modifiedBy.first_name;
      return modifiedBy.first_name + " " + modifiedBy.last_name;
    }
    return t("unknown", null, "capital");
  };

  useEffect(() => {
    if (createdBy.id !== null && createdBy.pending === true && createdBy.id == _user.data.id) {
      setCreatedBy({
        id: _user.data.id,
        first_name: _user.data.first_name,
        last_name: _user.data.last_name,
        pending: false,
      });

      if (typeof props.item.modified_by !== "undefined" && props.item.modified_by != null) {
        props.dispatch(
          userActions.getUser({
            token: Biscuit.get("token"),
            id: props.item.modified_by,
          }),
        );
        let clone: any = {};
        Object.assign(clone, modifiedBy);
        clone.id = props.item.modified_by;
        clone.pending = true;
        setModifiedBy(clone);
      }
      return;
    }

    if (modifiedBy.id !== null && modifiedBy.pending === true && modifiedBy.id == _user.data.id) {
      setModifiedBy({
        id: _user.data.id,
        first_name: _user.data.first_name,
        last_name: _user.data.last_name,
        pending: false,
      });
      return;
    }
  }, [_user]);

  useEffect(() => {
    console.log("use effect: ", props);
    if (
      props.shouldClose === true &&
      typeof closeButtonRef.current !== "undefined" &&
      closeButtonRef !== null
    ) {
      // @ts-ignore
      closeButtonRef?.current?.click();
    }
  });

  console.log("props: ", props);

  if (props.shouldClose === true) {
    console.log("should close: ", closeButtonRef);
    if (typeof closeButtonRef.current !== "undefined" && closeButtonRef.current !== null) {
      console.log("trigger close");
      // @ts-ignore
      closeButtonRef?.current?.click();
    } else {
      console.log("force close");
      //setForceClose(true);
    }
  }

  let saveButton = true;
  if (typeof props.noSaveButton !== "undefined") {
    saveButton = false;
  }
  let saveButtonName = t("save");
  if (typeof props.saveButtonName !== "undefined") {
    saveButtonName = props.saveButtonName;
  }
  return (
    <>
      <header className="inb-header off-canvas__header off-canvas--shadow clearfix row">
        <h1 className="inb-page-title">{props.heading}</h1>
        <div className="off-canvas__actions column">
          {saveButton && (
            <>
              <button
                type="submit"
                className={
                  "button medium beautify beautify-" +
                  Biscuit.get("user.client_id") +
                  " button-submit round"
                }
                title="Speichern"
                onClick={props.onSubmitHandler}
              >
                {props.isSaving === false && (
                  <>
                    <i className="fi fi-check"></i>
                    <span>{saveButtonName}</span>
                  </>
                )}
                {props.isSaving === true && (
                  <span>
                    <img className="rollingLoader" src="assets/img/rolling_loader.svg" />
                    {saveButtonName}
                  </span>
                )}
              </button>
            </>
          )}
          <a href={props.returnUrl}>
            <button
              ref={closeButtonRef}
              type="button"
              id="inb-resourcesform-abort-button"
              className="button hollow secondary right button-abort round"
              title="Fenster schließen"
              onClick={props.onCloseHandler}
            >
              <i className="fi fi-x"></i>
            </button>
          </a>
        </div>
      </header>
      {typeof props.item.id !== "undefined" && props.item.id != null && (
        <>
          {(typeof props.isOrder === "undefined" || !props.isOrder) && (
            <>
              <p className="off-canvas__subtitle off-canvas__header-region">
                {typeof props.item.created !== "undefined" &&
                  t("created_at") +
                    " " +
                    moment(props.item.created).format("DD.MM.YYYY HH:mm:ss") +
                    " " +
                    t("edited_by") +
                    " " +
                    getUsernameById(props.item.created_by) +
                    " | " +
                    t("last_modified_at") +
                    " " +
                    moment(props.item.modified).format("DD.MM.YYYY HH:mm:ss") +
                    " " +
                    t("edited_by") +
                    " " +
                    getUsernameById(props.item.modified_by)}
              </p>
            </>
          )}
          {(typeof props.isOrder !== "undefined" || props.isOrder) && (
            <>
              <p className="off-canvas__subtitle off-canvas__header-region">
                {typeof props.item.created !== "undefined" &&
                t("created_at") +
                  " " +
                  moment(props.item.created).format("DD.MM.YYYY HH:mm:ss") +
                  " " +
                  t("edited_by") +
                  " " +
                  getUsernameById(props.item.created_by) +
                  " | " +
                  t("last_modified_at") +
                  " " +
                  moment(props.item.modified).format("DD.MM.YYYY HH:mm:ss") +
                  " " +
                  t("edited_by") +
                  " " +
                  getUsernameById(props.item.modified_by) +
                  (props.lastMessage !== null && typeof props.lastMessage.created !== "undefined"
                    ? t("order_executed_at_${a}_with_active_status", {
                        a: moment(props.lastMessage.created).format("Do MMMM YYYY, HH:mm"),
                      })
                    : "") +
                  (typeof props.executed !== "undefined" &&
                    props.executed !== "" &&
                    props.executed !== null)
                  ? t("order_executed_at_${a}_with_active_status", {
                      a: moment(props.executed).format("Do MMMM YYYY, HH:mm"),
                    })
                  : ""}
              </p>
            </>
          )}
        </>
      )}
    </>
  );
};

export default OffcanvasHeader;
